import { Protocol } from '../Protocol';

export class AuthProtocol {
  public static readonly LOGIN_URL: string = `${Protocol.YATUNG_AUTH}CA017`;
  public static readonly GET_JWT: string = `${Protocol.YATUNG_AUTH}CA060`;
  public static readonly GET_USER_DATA: string = `${Protocol.YATUNG_AUTH}CA059`;
  public static readonly GET_USER_GROUPS_DATA: string = `${Protocol.YATUNG_API_ROOT}/users/group/detail`;
  public static readonly GET_USER_API_PERMISSION: string = `${Protocol.YATUNG_AUTH}CA063`;
}
